import { useQuery } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";

export interface RevenueByPlanData {
  plan_id: string;
  plan_name: string;
  total_income: number;
  total_refunds: number;
  net_income: number;
}

export const getRevenueByPlan = async () => {
  try {
    const response = await Axios.get<RevenueByPlanData[]>(
      `/revenue_report/revenue/by-plan`
    );
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    if (error.response) {
      throw new Error(error?.response?.data?.message || error?.response?.data?.error || "Error fetching revenue by plan data");
    }
    throw new Error(error.message || "Network Error");
  }
};

export const useGetRevenueByPlan = () => {
  return useQuery({
    queryKey: ["revenue_by_plan"],
    queryFn: getRevenueByPlan,
  });
};